import React from "react";
import { useTranslation } from 'react-i18next';

import IconButton from "@mui/material/IconButton";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import AtmIcon from "@mui/icons-material/Atm";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import SchoolIcon from "@mui/icons-material/School";
import HotelIcon from "@mui/icons-material/Hotel";
import CloseIcon from "@mui/icons-material/Close";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ChurchIcon from "@mui/icons-material/Church";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import FlutterDashIcon from "@mui/icons-material/FlutterDash";
import MosqueIcon from "@mui/icons-material/Mosque";
import DeckIcon from "@mui/icons-material/Deck";
import NightShelterIcon from "@mui/icons-material/NightShelter";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import * as colors from "@mui/material/colors";
import { SearchResult } from "./search-result";
import CommentBankIcon from '@mui/icons-material/CommentBank';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import ChurchOutlinedIcon from '@mui/icons-material/ChurchOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { faPlaceOfWorship, faChurch } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CATEGORIES = [
  {
    id: "Resort Centers",
    icon: "Resort.png",
  },
  {
    id: "Restaurant",
    icon: "Restaurant.png",
  },
  {
    id: "Hotels",
    icon: "Hotel.png",
  },
  {
    id: "Guest House/ Pension",
    icon: "Guest_House.png",
  },
  {
    id: "Pharmacy",
    icon: "Pharmacy.png",
  },
  {
    id: "Hospital",
    icon: "Hospital.png",
  },
  {
    id: "Bank",
    icon: "Bank.png",
  },
  {
    id: "ATM",
    icon: "ATM.png",
  },
  {
    id: "Supermarket",
    icon: "Supermarket.png",
  },
  {
    id: "Police Station",
    icon: "Police.png",
  },
  {
    id: "Fuel Station",
    icon: "Fuel_Station.png",
  },

  {
    id: "University",
    icon: "University.png",
  },
  {
    id: "Mosque",
    icon: "Mosque.png",
  },
  {
    id: "Orthodox Tewahedo Church",
    icon: "Orthodox_Church.png",
  },
  {
    id: "Catholic Church",
    icon: "Catholic_Church.png",
  },
  {
    id: "Protestant Church",
    icon: "Protestant_Church.png",
  },



];
export const Category = ({
  title,
  selected,
  setActiveTab,
  onSelect = () => { },
  onClose = () => { },
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Box
        sx={{
          backgroundColor: colors.common.white,
          borderRadius: 1,
          marginTop: "10px",
          padding: "10px",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          paddingLeft: "15px",
          paddingRight: "15px",
          boxShadow: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: "14px",
            }}
          >
            {title}
          </Typography>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Grid
          container
          spacing={2}
          sx={{
            maxWidth: "100%",
          }}
        >
          {CATEGORIES.map((category) => (
            <Grid item xs={3} sm={2.4} md={2} key={category.id}>
              <Tooltip title={t(category.id)} placement="top">
                <IconButton
                  size="small"
                  sx={{
                    borderColor:
                      selected === category.id
                        ? colors.blue[300]
                        : colors.grey[300],
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                  onClick={() => onSelect(category.id)}
                >
                  {
                    <img style={{ width: "25px", height: "25px", color: "red" }} src={category.icon} />

                  }
                </IconButton>
              </Tooltip>
            </Grid>
          ))}
          {/* <FontAwesomeIcon icon={faPlaceOfWorship} style={{ "border-radius": "50%",
  "border": "2px solid #D3D3D3",
  "padding": "5px",
  "marginLeft": "16px",
  "marginTop": "16px",
  "font-size": "20px",
"color": selected === "Protestant Church" ?colors.blue[600]:colors.grey[600]}}
                  onClick={() => onSelect("Protestant Church")} title="Protestant Church" />

<FontAwesomeIcon icon={faChurch} style={{ "border-radius": "50%",
  "border": "2px solid #D3D3D3",
  "padding": "5px",
  "marginLeft": "26px",
  "marginTop": "16px",
  "font-size": "20px",
  "color": selected === "Catholic Church" ?colors.blue[600]:colors.grey[600]}}
                  onClick={() => onSelect("Catholic Church")} title="Catholic Church" /> */}
        </Grid>
      </Box>
      <SearchResult setActiveTab={setActiveTab} />
    </>
  );
};
